import './App.css';
import Asap from './asap.jsx';
import Footer from "./footer";

function App() {
    return (
        <>
            <Asap/>
            <Footer/>
        </>
    );
}

export default App;
